import 'whatwg-fetch';
import React from "react";
import i18n from 'i18n-js';

import SpinnerSVG from "./images/spinner.svg";
import Maps from "./Maps";

import download from "downloadjs";
import moment from "moment";
export let API_VERSION = "2.0.13";
const USE_TEST = false;
export const API_INFO = {
  infoLine: {
      newAPI: true,
      name: "getObsStats",
  },
  infoOBSLine: {
      newAPI: true,
      name: "getObsStats",
  },
  obsStats: {
      newAPI: true,
      name: "getObsStats",
  },
  obsShared: {
      newAPI: true,
      name: "obsShared",
  },
  obsMonths: {
      newAPI: true,
      name: "getOBSsMonths",
  },
  raComments: {
      newAPI: true,
      name: "countRAWords",
  },
  raSumAnswers: {
      newAPI: true,
      name: "sumRAanswers",
  },
  ra: {
      newAPI: false,
      name: "allReports",
  },
  users: {
      newAPI: true,
      name: "getUsers",
  },
  obs: {
      newAPI: true,
      name: "getReports",
      // extras: [{
      //   name: "sheets",
      //   value: [81],
      // }],
  },
  allObs: {
      newAPI: true,
      name: "getReports",
      getAll: false,
      extras: [{
        name: "sheets",
        value: [81],
      },{
        name: "limited",
        value: 0,
      },],
  },
  userPoints: {
      newAPI: true,
      name: "getUserPoints",
      getAll: true,
  },
  allDepartments: {
      newAPI: true,
      name: "getDepartments",
      getAll: true,
  },
  departments: {
      newAPI: true,
      name: "getMyDepartments",
      getAll: true,
  },
};

export function DAWA(endpoint) {
  return fetch("https://dawa.aws.dk/" + endpoint).then(d => d.json()).catch(d => false);
};

export const PANEL_TYPES = {
      DEPARTMENT_INFO: {
        type: ["departments", "allDepartments", "allObs", "users"],
        panelSize: "half",
        newAPI: true,
        extraValue: "",
        extraName: "sheetIDs (seperated by ,)",
      },
      REPORT_MAP: {
        type: ["allObs", "users"],
        panelSize: "half",
        newAPI: true,
        extraValue: "",
        extraName: "sheetIDs (seperated by ,)",
      },
      INFO_LINE:{
        type: ["ra", "obs", "users"],
        panelSize: "full",
        newAPI: true,
        fullScreen: true,
      },
      INFO_OBS_LINE:{
        type: ["allObs", "users", "departments"],
        panelSize: "full",
        newAPI: true,
        fullScreen: true,
        extraValue: "",
        extraName: "sheetIDs (seperated by ,)",
      },
      OBS_TYPES:{
        type: ["obsStats"],
        panelSize: "half",
        newAPI: true,
        extraValue: "",
        extraName: "sheetID",
      },
      USER_POINTS:{
        type: ["userPoints"],
        panelSize: "half",
        newAPI: true,
      },
      OBS_SHARE:{
        type: ["obsShared"],
        panelSize: "half",
        newAPI: true,
      },
      OBS_KPI:{
        type: ["obs", "obsMonths"],
        panelSize: "full",
        newAPI: true,
        extraValue: "",
        extraName: "sheetIDs (seperated by ,)",
      },
      OBS_LOCAL_KPI:{
        type: ["obs", "departments", "users"],
        panelSize: "full",
        newAPI: true,
      },
      OBS_LOCAL_MONTH_KPI:{
        type: ["obs", "departments", "users"],
        panelSize: "full",
        newAPI: true,
      },
      RA_COMMENTS:{
        type: ["raComments"],
        panelSize: "half",
        newAPI: true,
      },
      RA_POINTS_PIE: {
        type: ["raSumAnswers"],
        panelSize: "third",
        extraValue: "",
        extraName: "sheetID",
        newAPI: true,
      },
      RA_POINTS_BARS: {
        type: ["raSumAnswers"],
        panelSize: "third",
        extraValue: "",
        extraName: "sheetID",
        newAPI: true,
      },
      LAST_RA_TABLE: {
        type: ["ra", "users"],
        panelSize: "half",
        newAPI: false,
      },
      LAST_RA_OBS_TABLE: {
        type: ["users", "obs"],
        panelSize: "half",
        newAPI: false,
      },
      POINTS_LINE: {
        type: ["ra"],
        panelSize: false,
        newAPI: false,
      },
    };


export function intRange(to = 10, fromI = 0)
{
  let ret = [];
  for(let i = fromI; i < to; i++)
  {
    ret.push(i);
  }
  return ret;
};
export function arrMove(old_index, new_index, data)
{
  let comps = [...data];
  if (new_index >= comps.length) {
    var k = new_index - comps.length;
    while ((k--) + 1) {
        comps.push(undefined);
    }
  }
  comps.splice(new_index, 0, comps.splice(old_index, 1)[0]);
  return comps;
}

export function toString(value)
{
  let ret = "";
  switch(typeof value)
  {
    case "number":
      ret = value.toString();
    break;
    case "string":
      ret = value;
    break;
    case "object":
      ret = JSON.stringify(value);
    break;
    default:
      console.log("Couldnt convert type", typeof value, "to string", value);
    break;
  }
  return ret;
}
export const actionColors = ["#ff0000", "rgb(199, 199, 8)", "#008000", "#808080"];
export function isBusinessDay(moment){
  var day = moment.day();
  return !(day == 0 || day == 6);
}
export function getPreviousWorkday(start) {
  return [1, 2, 3, 4, 5].indexOf(moment(start).subtract(1, 'day').day()) > -1 ? 
    moment(start).subtract(1, 'day') : moment(moment(start).day(-2));
}


export function findAnswer(questions = [], questionID = 0)
{
  for(let i = 0; i < questions.length; i++)
  {
    const curr = questions[i];
    if(curr.questionID === questionID)
    {
      return curr;
    }
    let childCheck = findAnswer(curr.children, questionID);
    if(childCheck)
    {
      return childCheck;
    }
  }
  return false;
}

export function findParent(questions = [], checkFunc = () => true, parent = null)
{
  for(let i = 0; i < questions.length; i++)
  {
    const curr = questions[i];
    if(checkFunc(curr))//curr.questionID === questionID)
    {
      return parent;
    }
    let childCheck = findParent(curr.children, checkFunc, curr);
    if(childCheck)
    {
      return childCheck;
    }
  }
  return false;
}

export const smileys = ["green", "yellow", "red"];
export function formatQuestionResponse(question, questionSheet, me = false)
{
  const answerParent = findParent(questionSheet, curr => curr.questionID === question.questionID);
  const answer = findAnswer(questionSheet, question.questionID);
  // console.log("Q", question, answer, answerParent);

  const questionWrapper = (value, translate = true) => {
    if(answerParent && answerParent.type === "valueChecker")
    {
      const correct = answerParent.correct.includes(value);
      return <React.Fragment>
          <i className={correct ? "fa fa-check" : "fa fa-times"} style={{fontWeight: "bolder", color: correct ? "green" : "red", paddingRight: "5px"}} aria-hidden="true"></i>
          {translate ? i18n.t(value) : value}
        </React.Fragment>;
      return <div style={{fontWeight: "bolder"}}>{value}</div>
    }

    return translate ? i18n.t(value) : value;
  };
  switch(question.type)
  {
    case "upload":
      const images = question.response.map(fileName => `${IP}/image/${fileName}`);
      return (<React.Fragment>
        {
          images.map((image, i) => <img src={image} onClick={() => {
            if(me)
            {
              const IMG = image;
              const ref = me.refs.thumb;
              if(ref.src !== IMG)
              {
                ref.style.transform = "rotate(0deg)";
                ref.src = IMG;
                // ref.dataset.images = JSON.stringify(images);
                // ref.dataset.currI = i;
                if(window.updateModalImg)
                {
                  window.updateModalImg(images, i);
                }
              }
            }
          }} data-toggle="modal" data-target=".bs-example-modal-lg.imgModal" style={{width: "100px", cursor: "zoom-in", marginRight: "10px"}} />)
        }
      </React.Fragment>);
    break;
    case "mapPicker":
        const tempFixMaxI = Number(question.response[0]) > Number(question.response[1]) ? 1 : 0;
        const tempFixMinI = tempFixMaxI === 1 ? 0 : 1;
        return <Maps data={question.response.length === 2 ? [[question.response[tempFixMinI], question.response[tempFixMaxI]]] : []} style={{height: "300px", width:"350px"}} />
    break;
    case "points":
        let point = question.response.reduce((a, b) => a + Number(b), 0);
        return (<div>{point}</div>);
    break;
    case "multilineInput":
        return questionWrapper(question.response, false);
    break;
    case "select":
        return questionWrapper(question.response.map(d => i18n.t(d)).join(", "), false);
    break;
    case "textInput":
    case "input":
        return questionWrapper(question.response.join(","), false);
    break;
    case "smileys_colored":
    case "smileys":
        
        return questionWrapper(question.response.map(resp => <img src={`/includes/images/smiley/${smileys[resp]}.png`} style={{width: "40px"}} />), false);
    break;
    case "boolean":
        {
          const temp = question.response.map(i => answer.options[Number(i)]);
          return questionWrapper(temp.join(","));
        }
    break;

    //findAnswer
    case "addressInput":
      const addrData = question.response[2];
      // console.log("Addr", addrData, question);
      if(addrData)
      {
        // console.log({lat: addrData.geo[1], lng: addrData.geo[0]});
      }
        return question.response.length > 1 ? (question.response.length === 2 ? <img style={{width: "25px"}} src={SpinnerSVG}/> : <div>
          {addrData.name}
          {
            addrData.geo && <Maps data={[addrData.geo]} style={{height: "380px"}} />
          }
        </div>) : <div/>;
    break;
  }
  const responses = question.response.map(id => findAnswer(questionSheet, Number(id))); // this.state.reportData.sheet.questions
  // console.log(question.response, questionSheet);
  // console.log("Responses", responses, questionSheet);
  return questionWrapper(responses.filter(d => !!d).map(d => d.question).join(", "));
}

// export function findParent(questions = [], questionID = 0)
// {
//   for(let i = 0; i < questions.length; i++)
//   {
//     const curr = questions[i];
    
//     for(let j = 0; j < curr.children.length; j++)
//     {
//       const child = curr.children[j];
//       if(child.questionID === questionID)
//       {
//         return curr;
//       }
//     }
    
//     let childCheck = findAnswer(curr.children, questionID);
//     if(childCheck)
//     {
//       return childCheck;
//     }
//   }
//   return false;
// }

export function obsDataParser(stateData)
{
    return new Promise(r => {
      stateData.questions
        .map((d, k) => ({...d, key: k}))
        .filter(question => ["addressInput"].includes(question.type))
        .forEach(async question => {
          if(question.type === "addressInput")
          {
            if(question.response.length >= 2)
            {
              let data = await DAWA(`adresser?id=${question.response[1]}`);
              if(data && data.length > 0)
              {
                const target = data[0];
                let obj = {
                  name: target.adressebetegnelse,
                  geo: false,
                };
                if(target.adgangsadresse && target.adgangsadresse.adgangspunkt)
                {
                  obj.geo = target.adgangsadresse.adgangspunkt.koordinater;
                }
                r({
                  ...stateData,
                  questions: stateData.questions.map((d, key) => {
                    if(key === question.key)
                    {
                      d.response.push(obj);
                    }
                    return d;
                  })
                });
              }
            }
          }
      });
    });
}

export function departmentTable(currDep, deepInfo = false, level = 0)
{
  let ret = [
    deepInfo ? [currDep.id, currDep.name, level, currDep] : [currDep.id, currDep.name, level],
  ];
  currDep.subDepartments.map(dep => departmentTable(dep, deepInfo, level + 1).map(newDep => {
    ret.push(deepInfo ? [...newDep, dep] : newDep);
  }));
  return ret;
}

export function betterDepartmentTable(currDep, deepInfo = false, level = 0)
{
  let ret = [
    deepInfo ? [currDep.id, currDep.name, level, currDep] : [currDep.id, currDep.name, level],
  ];
  (currDep.children || []).map(dep => betterDepartmentTable(dep, deepInfo, level + 1).map(newDep => {
    ret.push(deepInfo ? [...newDep, dep] : newDep);
  }));
  return ret;
}

export function departmentIDs(currDep)
{
  let ret = [
    currDep.id
  ];
  currDep.subDepartments.map(dep => departmentIDs(dep).map(newDep => {
    ret.push(newDep);
  }));
  return ret;
}

export function beutifyDepartments(arr, selected)
{
  if(typeof arr !== "object")
  {
    return [];
  }
  let ret = [];
  let checkArr = [...arr];

  for(let i = 0; i < checkArr.length; i++)
  {
    let extras = "";
    let d = checkArr[i];
    if(d.linkedTo)
    {
      for(let i = 0; i < d.level; i++)
      {
        extras += "--";
      }
      extras += ">";
    }
    ret.push({
      selected: selected === d.id ? true : false,
      value: d.id,
      key: "dep" + i,
      text: extras + " #" + d.id + " " + d.name, 
    });
    if(d.subDepartments && d.subDepartments.length > 0)
    {
      let currLevel = d.level ? d.level : 0;
      checkArr = [
        ...checkArr.filter((d, key) => key <= i),
        ...d.subDepartments.map((d2) => ({...d2, linkedTo: d.id, level: currLevel + 1})),
        ...checkArr.filter((d, key) => key > i),
      ];
    }
  }

  return ret;
  /*return arr.map((d, key) => {
      let extras = "";
      if(d.linkedTo)
      {
        for(let i = 0; i < d.level; i++)
        {
          extras += "--";
        }
        extras += ">";
      }
      return {
        selected: selected === d.id ? true : false,
        value: d.id,
        key: "dep" + key,
        text: extras + " #" + d.id + " " + d.name, 
      };
      //return (<option key={"dep" + key} value={d.id} selected={selected === d.id ? true : false}>{extras} #{d.id} {d.name}</option>);
    });*/
};

export const VALID_LANGS = ["EN", "DK"];
export const VALID_LANG_CODES = ["en-US", "da-DK"];
export function classLoader(val, className)
{
  return val.length > 0 ? className : className + " loadingField";
}
export const storageName = "safealldayBackendz7";
export function percent(val, off)
{
  return val/off * 100;
}
export function lastWeekFunc(now, last)
{
  const ret = [];
  ret['last'] = percent(last, now);
  ret['now'] = percent(now, last);

  ret['higher'] = ret['now'] > ret['last'];
  ret['percent'] = decimals(ret['now'] - ret['last'], 2);
  return ret;
}

export function getArr(length){
  var arr = [];
  for(var i = 0; i < length; i++)
  {
    arr.push("d");
  }
  return arr;
}

export function decimals(val, decimals)
{
  let zeroes = 10 * decimals;
  val = val * zeroes;
  val = Math.round(val) / zeroes;
  return val;
  /*val = val * Math.pow(10, decimals);
  val = Math.round(val) / Math.pow(10, decimals);
  return val;*/
}

/*
 *dataFind([{
              key: "createdBy",
              value: d.id.toString(),
            }], {
              key: "time",
              type: "DESC",
            }, 1, DAT.ra)
 */
function booleanFindCheck(type)
{
  if(type === "=")
  {
    return (a, b) => a !== b; 
  }else if(type === ">")
  {
    return (a, b) => !(a > b); 
  }else if(type === "<")
  {
    return (a, b) => !(a < b); 
  } 
  return (a, b) => true;
}
export function dataFind(WHERE, ORDER, LIMIT, data)
{
  /*
  val = 5
  find = > 1 && < 10
  */
  //console.log("dataFInd", data);
  let set = data.filter((d) => {
    let check = WHERE.find((WHER) => booleanFindCheck(WHER.type)(d[WHER.key], WHER.value));
    if(!check)
    {
      return true;
    }
    return false;
  });

  if(ORDER)
  {
    set = set.sort((a,b) => {
      let check = ORDER.type === "DESC" ? a[ORDER.key] > b[ORDER.key] : a[ORDER.key] < b[ORDER.key];
      return check ? 1 : -1;
    });
  }

  if(LIMIT)
  {
    set = set.filter((d, key) => key < LIMIT);
  }
  return set;
};

export function parsePHPtime(val)
{
  var date = new Date(val*1000);
  var month = date.getMonth() + 1;
  month = month < 10 ? ("0" + month) : month;

  var day = date.getDate();
  day = day < 10 ? ("0" + day) : day;

  var hours = date.getHours();
  hours = hours < 10 ? ("0" + hours) : hours;

  var minutes = date.getMinutes();
  minutes = minutes < 10 ? ("0" + minutes) : minutes;

  var seconds = date.getSeconds();
  seconds = seconds < 10 ? ("0" + seconds) : seconds;


  return date.getFullYear() + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds; 
}
export function hashCode(string)
{
  var hash = 0, i, chr;
  if (string.length === 0) return hash;
  for (i = 0; i < string.length; i++) {
    chr   = string.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
export function hexToRgbA(hex, a = 1){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + a +')';
    }
    throw new Error('Bad Hex');
}
export function rndRGB()
{
  return [Math.floor(Math.random() * 255), Math.floor(Math.random() * 255), Math.floor(Math.random() * 255)];
}

export function generateRandomColors(number){
  /*
  This generates colors using the following algorithm:
  Each time you create a color:
      Create a random, but attractive, color{
          Red, Green, and Blue are set to random luminosity.
          One random value is reduced significantly to prevent grayscale.
          Another is increased by a random amount up to 100%.
          They are mapped to a random total luminosity in a medium-high range (bright but not white).
      }
      Check for similarity to other colors{
          Check if the colors are very close together in value.
          Check if the colors are of similar hue and saturation.
          Check if the colors are of similar luminosity.
          If the random color is too similar to another,
          and there is still a good opportunity to change it:
              Change the hue of the random color and try again.
      }
      Output array of all colors generated
  */
      //if we've passed preloaded colors and they're in hex format
      if(typeof(arguments[1])!='undefined'&&arguments[1].constructor==Array&&arguments[1][0]&&arguments[1][0].constructor!=Array){
          for(var i=0;i<arguments[1].length;i++){ //for all the passed colors
              var vals = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(arguments[1][i]); //get RGB values
              arguments[1][i]=[parseInt(vals[1], 16),parseInt(vals[2], 16),parseInt(vals[3], 16)]; //and convert them to base 10
          }
      }
      var loadedColors=typeof(arguments[1])=='undefined'?[]:arguments[1],//predefine colors in the set
          number=number+loadedColors.length,//reset number to include the colors already passed
          lastLoadedReduction=Math.floor(Math.random()*3),//set a random value to be the first to decrease
          rgbToHSL=function(rgb){//converts [r,g,b] into [h,s,l]
              var r=rgb[0],g=rgb[1],b=rgb[2],cMax=Math.max(r,g,b),cMin=Math.min(r,g,b),delta=cMax-cMin,l=(cMax+cMin)/2,h=0,s=0;if(delta==0)h=0;else if(cMax==r)h=60*((g-b)/delta%6);else if(cMax==g)h=60*((b-r)/delta+2);else h=60*((r-g)/delta+4);if(delta==0)s=0;else s=delta/(1-Math.abs(2*l-1));return[h,s,l]
          },hslToRGB=function(hsl){//converts [h,s,l] into [r,g,b]
              var h=hsl[0],s=hsl[1],l=hsl[2],c=(1-Math.abs(2*l-1))*s,x=c*(1-Math.abs(h/60%2-1)),m=l-c/2,r,g,b;if(h<60){r=c;g=x;b=0}else if(h<120){r=x;g=c;b=0}else if(h<180){r=0;g=c;b=x}else if(h<240){r=0;g=x;b=c}else if(h<300){r=x;g=0;b=c}else{r=c;g=0;b=x}return[r,g,b]
          },shiftHue=function(rgb,degree){//shifts [r,g,b] by a number of degrees
              var hsl=rgbToHSL(rgb); //convert to hue/saturation/luminosity to modify hue
              hsl[0]+=degree; //increment the hue
              if(hsl[0]>360){ //if it's too high
                  hsl[0]-=360 //decrease it mod 360
              }else if(hsl[0]<0){ //if it's too low
                  hsl[0]+=360 //increase it mod 360
              }
              return hslToRGB(hsl); //convert back to rgb
          },differenceRecursions={//stores recursion data, so if all else fails we can use one of the hues already generated
              differences:[],//used to calculate the most distant hue
              values:[]//used to store the actual colors
          },fixDifference=function(color){//recursively asserts that the current color is distinctive
              if(differenceRecursions.values.length>23){//first, check if this is the 25th recursion or higher. (can we try any more unique hues?)
                  //if so, get the biggest value in differences that we have and its corresponding value
                  var ret=differenceRecursions.values[differenceRecursions.differences.indexOf(Math.max.apply(null,differenceRecursions.differences))];
                  differenceRecursions={differences:[],values:[]}; //then reset the recursions array, because we're done now
                  return ret; //and then return up the recursion chain
              } //okay, so we still have some hues to try.
              var differences=[]; //an array of the "difference" numbers we're going to generate.
              for(var i=0;i<loadedColors.length;i++){ //for all the colors we've generated so far
                  var difference=loadedColors[i].map(function(value,index){ //for each value (red,green,blue)
                      return Math.abs(value-color[index]) //replace it with the difference in that value between the two colors
                  }),sumFunction=function(sum,value){ //function for adding up arrays
                      return sum+value
                  },sumDifference=difference.reduce(sumFunction), //add up the difference array
                  loadedColorLuminosity=loadedColors[i].reduce(sumFunction), //get the total luminosity of the already generated color
                  currentColorLuminosity=color.reduce(sumFunction), //get the total luminosity of the current color
                  lumDifference=Math.abs(loadedColorLuminosity-currentColorLuminosity), //get the difference in luminosity between the two
                  //how close are these two colors to being the same luminosity and saturation?
                  differenceRange=Math.max.apply(null,difference)-Math.min.apply(null,difference),
                  luminosityFactor=50, //how much difference in luminosity the human eye should be able to detect easily
                  rangeFactor=75; //how much difference in luminosity and saturation the human eye should be able to dect easily
                  if(luminosityFactor/(lumDifference+1)*rangeFactor/(differenceRange+1)>1){ //if there's a problem with range or luminosity
                      //set the biggest difference for these colors to be whatever is most significant
                      differences.push(Math.min(differenceRange+lumDifference,sumDifference));
                  }
                  differences.push(sumDifference); //otherwise output the raw difference in RGB values
              }
              var breakdownAt=64, //if you're generating this many colors or more, don't try so hard to make unique hues, because you might fail.
              breakdownFactor=25, //how much should additional colors decrease the acceptable difference
              shiftByDegrees=15, //how many degrees of hue should we iterate through if this fails
              acceptableDifference=250, //how much difference is unacceptable between colors
              breakVal=loadedColors.length/number*(number-breakdownAt), //break down progressively (if it's the second color, you can still make it a unique hue)
              totalDifference=Math.min.apply(null,differences); //get the color closest to the current color
              if(totalDifference>acceptableDifference-(breakVal<0?0:breakVal)*breakdownFactor){ //if the current color is acceptable
                  differenceRecursions={differences:[],values:[]} //reset the recursions object, because we're done
                  return color; //and return that color
              } //otherwise the current color is too much like another
              //start by adding this recursion's data into the recursions object
              differenceRecursions.differences.push(totalDifference);
              differenceRecursions.values.push(color);
              color=shiftHue(color,shiftByDegrees); //then increment the color's hue
              return fixDifference(color); //and try again
          },color=function(){ //generate a random color
              var scale=function(x){ //maps [0,1] to [300,510]
                  return x*210+300 //(no brighter than #ff0 or #0ff or #f0f, but still pretty bright)
              },randVal=function(){ //random value between 300 and 510
                  return Math.floor(scale(Math.random()))
              },luminosity=randVal(), //random luminosity
                  red=randVal(), //random color values
                  green=randVal(), //these could be any random integer but we'll use the same function as for luminosity
                  blue=randVal(),
                  rescale, //we'll define this later
                  thisColor=[red,green,blue], //an array of the random values
                  /*
                  #ff0 and #9e0 are not the same colors, but they are on the same range of the spectrum, namely without blue.
                  Try to choose colors such that consecutive colors are on different ranges of the spectrum.
                  This shouldn't always happen, but it should happen more often then not.
                  Using a factor of 2.3, we'll only get the same range of spectrum 15% of the time.
                  */
                  valueToReduce=Math.floor(lastLoadedReduction+1+Math.random()*2.3)%3, //which value to reduce
                  /*
                  Because 300 and 510 are fairly close in reference to zero,
                  increase one of the remaining values by some arbitrary percent betweeen 0% and 100%,
                  so that our remaining two values can be somewhat different.
                  */
                  valueToIncrease=Math.floor(valueToIncrease+1+Math.random()*2)%3, //which value to increase (not the one we reduced)
                  increaseBy=Math.random()+1; //how much to increase it by
              lastLoadedReduction=valueToReduce; //next time we make a color, try not to reduce the same one
              thisColor[valueToReduce]=Math.floor(thisColor[valueToReduce]/16); //reduce one of the values
              thisColor[valueToIncrease]=Math.ceil(thisColor[valueToIncrease]*increaseBy) //increase one of the values
              rescale=function(x){ //now, rescale the random numbers so that our output color has the luminosity we want
                  return x*luminosity/thisColor.reduce(function(a,b){return a+b}) //sum red, green, and blue to get the total luminosity
              };
              thisColor=fixDifference(thisColor.map(function(a){return rescale(a)})); //fix the hue so that our color is recognizable
              if(Math.max.apply(null,thisColor)>255){ //if any values are too large
                  rescale=function(x){ //rescale the numbers to legitimate hex values
                      return x*255/Math.max.apply(null,thisColor)
                  }
                  thisColor=thisColor.map(function(a){return rescale(a)});
              }
              return thisColor;
          };
      for(var i=loadedColors.length;i<number;i++){ //Start with our predefined colors or 0, and generate the correct number of colors.
          loadedColors.push(color().map(function(value){ //for each new color
              return Math.round(value) //round RGB values to integers
          }));
      }
      //then, after you've made all your colors, convert them to hex codes and return them.
      return loadedColors.map(function(color){
          var hx=function(c){ //for each value
              var h=c.toString(16);//then convert it to a hex code
              return h.length<2?'0'+h:h//and assert that it's two digits
          }
          return "#"+hx(color[0])+hx(color[1])+hx(color[2]); //then return the hex code
      });
  }

export function colorRange(colorNum, colors){
  /*if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
  return "hsl(" + (colorNum * (360 / colors) % 360) + ",100%,50%)";*/
  const hue = colorNum * 137.508; // use golden angle approximation
  return `hsl(${hue},100%,50%)`;
}


export function string_to_color(str, prc, hex = true) {
  /*var hash = 0;
  if (str.length === 0) return hash;
  for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
  }
  if(hex)
  {
    var color = '#';
    for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 255;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  }else{
    var rgb = [0, 0, 0];
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 255;
      rgb[i] = value;
    }
    return rgb;//`rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
  }*/


  var input_str = str;
   var baseRed = 160;
    var baseGreen = 160;
    var baseBlue = 160;

    var seed = input_str.charCodeAt(0) ^ input_str.charCodeAt(1);
    var rand_1 = Math.abs((Math.sin(seed++) * 10000)) % 256;
    var rand_2 = Math.abs((Math.sin(seed++) * 10000)) % 256;
    var rand_3 = Math.abs((Math.sin(seed++) * 10000)) % 256;

    //build colour
    var red = Math.round((rand_1 + baseRed) / 2);
    var green = Math.round((rand_2 + baseGreen) / 2);
    var blue = Math.round((rand_3 + baseBlue) / 2);

    var rgb = blue | (green << 8) | (red << 16);
    if(hex)
    {
      return  (0x1000000 + rgb).toString(16).slice(1);
    }else{
      return [red, green, blue];
    }


  var color = "";
  for (var i = 0, hash = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash));
    color = Math.floor(Math.abs((Math.sin(hash) * 10000) % 1 * 16777216)).toString(16);
    return '' + Array(6 - color.length + 1).join('0') + color;

   var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var colour = '';
  for (var i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xFF;
    colour += ('00' + value.toString(16)).substr(-2);
  }
  return colour;
};

export function rgbToHex(v1)
{
 /* var rgb = v1[0] | (v1[1] << 8) | (v1[2] << 16);
  return  (0x1000000 + rgb).toString(16).slice(1);*/
  const test = (r, g, b) => [r, g, b].map(x => {
    const hex = x.toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }).join('');
  return test(v1[0], v1[1], v1[2]);
  
};

export function euclidian(v1, v2){
  var i,
      d = 0;

  for (i = 0; i < v1.length; i++) {
      d += (v1[i] - v2[i])*(v1[i] - v2[i]);
  }
  return Math.sqrt(d);
}

export function get(method, data, callback, auth, newAPI) {
    if(!method)
    {
      method = "GET";
    }
    if(!data)
    {
      data = {};
    }
    var extra = "";
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      extra = "?errz";
    }

    var headers = {'Content-Type': 'text/plain'};
    if(auth)
    {
      headers.tag = auth;
    }
    headers.v = API_VERSION;
    var tag = false;
     fetch((USE_TEST ? 'http://safeallday-env.m6u8vtvx2p.eu-central-1.elasticbeanstalk.com/backend/' : "https://safeallday.dk/backend/") + (newAPI ? "newApi" : "api") + '.php' + extra,{
        method: method,
        body: JSON.stringify(data),
        headers: headers
      })
      .then(function(response) {
        return response.blob();
      }).then(function(blob) {
        download(blob);
        if(callback)
        {
          callback();
        }
      }).catch(function(e) {
        console.log(method, data, e);
        //alert("Der skete en fejl, prøv igen.");
    });
  };

export function cachedAPI(method, data, callback, auth, newAPI, cache = [])
{
  let maxDiff = 480;
  let dataCheck = cache.find(elem => elem.api === data.type && (data.interval.from - elem.from) <= maxDiff && (data.interval.to - elem.to) <= maxDiff);

  if(dataCheck && false)
  {
    setTimeout(() => {

      callback({
        error: false,
        fromCache: true,
        data: dataCheck.data,
      });
    }, 0);
  }else{
    api(method, data, callback, auth, newAPI);
  }
}

export function asyncApi(method, data, auth, newAPI) {
  return new Promise(r => api(method, data, r, auth, newAPI));
}


export const BRANCH_IPS = {
  "PROD": "https://api.safeallday.dk",
  "DEV": "https://api.safeallday.dk",
  // "DEV": "https://devapi.safeallday.dk",
};
export const IP = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && 0  ? "http://localhost:8080" : BRANCH_IPS[process.env.REACT_APP_MY_ENV || "DEV"];

export function api(method, data, callback, auth, newAPI, serverIP = IP) {
    if(!method)
    {
      method = "GET";
    }
    if(!data)
    {
      data = {};
    }
    var extra = "";
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      extra = "?errz";
    }

    var headers = {'Content-Type': 'application/json'};
    if(auth)
    {
      headers.token = auth;
    }
    headers.v = API_VERSION;
    var tag = false;
     fetch((serverIP + "/") + data.type,{
        method: method,
        body: JSON.stringify(data),
        headers: headers
      })
      .then(function(response) {
        tag = response.headers.get('tag');
        return response.json();
      }).then(function(body) {
        if(callback)
        {
           //console.log(response.headers.get('tag'));
          callback(body, tag);
        }
      }).catch(function(e) {
        console.log(method, data, e);
        //alert("Der skete en fejl, prøv igen.");
    });
  };

export function s2ab(s) {
    if (typeof ArrayBuffer !== 'undefined') {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i)
            view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    } else {
        var buf = new Array(s.length);
        for (var i = 0; i != s.length; ++i)
            buf[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
};

export function drawTable(rows, styles = [], enableDataTable = true, options = {"retrieve": true, "iDisplayLength": 50, "order": [[ 0, "desc" ]]}, ignoreCol = false, extraCol)
{
    return (<table className="table table-striped jambo_table bulk_action" ref={(table) => {
    // if(table && !this.props.fullPage && enableDataTable)
    // {
    // this.dataViewTable = window.$(table).DataTable(options);
    // }
  }}>
    <thead>
    <tr>
      {
      rows[0].map((col, key) => <th key={key}>{col}</th>)
      }
    </tr>
    </thead>
    <tbody>
    {rows.map((cols, key) => key !== 0 ? <tr key={key}>
    {
      cols.map((col, key2) => <td key={key + "-" + key2} style={styles[key - 1] ? styles[key - 1] : {}}>{ignoreCol === false || ignoreCol !== key2 ? toString(col) : col}</td>)
    }
    </tr> : null)}
    </tbody>
    
  </table>);
}

    


// WEBPACK FOOTER //
// ./src/components/baseFunctions.js